import { render } from "./BaseProposalListItem.vue?vue&type=template&id=efbe8998"
import script from "./BaseProposalListItem.vue?vue&type=script&lang=js"
export * from "./BaseProposalListItem.vue?vue&type=script&lang=js"

import "./BaseProposalListItem.vue?vue&type=style&index=0&id=efbe8998&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__